module.exports = __webpack_public_path__ + "img/43-20170509.ed645bf7.jpg";